const BigPockeetIcon = () => {
  return (
    <svg
      width="103"
      height="103"
      viewBox="0 0 142 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="sms">
        <path
          id="Vector"
          d="M100.206 120.837H41.2607C23.5773 120.837 11.7883 111.995 11.7883 91.3641L11.7883 50.1028C11.7883 29.4721 23.5773 20.6304 41.2607 20.6304L100.206 20.6304C117.889 20.6304 129.678 29.4721 129.678 50.1028V91.3641C129.678 111.995 117.889 120.837 100.206 120.837Z"
          stroke="#797979"
          stroke-width="1.49438"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M100.206 53.0503L81.7563 67.7865C75.685 72.62 65.7233 72.62 59.652 67.7865L41.2613 53.0503"
          stroke="#797979"
          stroke-width="1.49438"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export default BigPockeetIcon;
